module.exports = __webpack_public_path__ + "img/logo-white.518fb511.png";